import $ from 'jquery';
import config from '../../../config';

// Get Employee
export function get_employee(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee/',
			data: {
                method: 'GET_EMPLOYEE',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EMPLOYEE",
				employee: response
			})
		})

	}
}

// Delete Employee
export function delete_employee( employee_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee/',
			data: {
                method: 'DELETE_EMPLOYEE',
                employee_id: employee_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_EMPLOYEE",
				employee: response
			})
		})

	}
}

// Delete Employee
export function set_employee_approve( employee_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee/',
			data: {
                method: 'APPROVE_EMPLOYEE',
                employee_id: employee_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "APPROVE_EMPLOYEE",
				employee: response
			})
		})

	}
}

// Get Company
export function get_company(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee/',
			data: {
                method: 'GET_EMPLOYEE_COMPANY',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EMPLOYEE_COMPANY",
				employee: response
			})
		})

	}
}

// Get Employee
export function request_join_employee( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee/',
			data: {
				method: 'REQUEST_JOIN',
				data, data
            }
		})
		.then(function (response) {
			dispatch({
				type: "REQUEST_JOIN",
				employee: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/employee/actions/employee.action.js